import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class CompanyApi {
    static getAll() {
        return request.get('/company');
    }

    static get(id) {
        return request.get(`/company/${id}`);
    }

    static create(data) {
        return request.post('/company',{data: data });
    }

    static edit(data, id){
        return request.put(`/company/${id}`, {data: data});
    }

    static delete(id){
        return request.delete(`company?id=${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Company.js